
import React, { useState } from 'react';
import EsriLeafletMap from '../../esrileafletmap';
import LayerCard from '../../LayersCard';

import './ListingDetailsMap.scss';
import '../../../scss/_searchFilters.scss';

const ListingDetailsMap = (props) => {
    const { Latitude, Longitude, Zoom } = props;
    const [newLatitude] = useState(Latitude);
    const [newLongitude] = useState(Longitude);
    const [newZoom] = useState(Zoom);
    const [mapAdd, setMapAdd] = useState();
    const [menuLayersOpen, setMenuLayersOpen] = useState(false);
    const [layerSelected, setLayerSelected] = useState();
    const [poiSelected, setPoiSelected] = useState(
        {
            attraction: { featureType: 'poi.attraction', name: 'Attraction', enabled: false },
            business: { featureType: 'poi.business', name: 'Business', enabled: false },
            gov: { featureType: 'poi.government', name: 'Government', enabled: false },
            medical: { featureType: 'poi.medical', name: 'Medical', enabled: false },
            park: { featureType: 'poi.park', name: 'Park', enabled: true },
            worship: { featureType: 'poi.place_of_worship', name: 'Place of Worship', enabled: false },
            shcool: { featureType: 'poi.school', name: 'School', enabled: false },
            sports: { featureType: 'poi.sports_complex', name: 'Sports Complex', enabled: false }
        }
    )
    const [all_layers] = useState(JSON.parse(process.env.REACT_APP_Map_Layers || []));

    const selectPoi = (k,v) => {
        setPoiSelected({
            ...poiSelected,
            [k]: {
                ...poiSelected[k],
                enabled: v
            }
        })
    };


    return <>
        <EsriLeafletMap
            {...props}
            Latitude={newLatitude}
            Longitude={newLongitude}
            Zoom={newZoom}
            allowLayers={true}
            mapAdd={mapAdd}
            setMapAdd={(map) => setMapAdd(map)}
            layers={all_layers}
            openMenuLayers={() => setMenuLayersOpen(true)}
            layerSelected={layerSelected}
            poiSelected={poiSelected}
            fitBounds={false}
        />
        <div className="listing-details-map">
            <LayerCard
                boundaries={false}
                layers={all_layers}
                open={menuLayersOpen}
                onClose={() => setMenuLayersOpen(false)}
                layerSelected={layerSelected}
                setlayerSelected={layerSelected => setLayerSelected(layerSelected)}
                poiSelected={poiSelected}
                setPoiSelected={selectPoi}
            />
        </div>
    </>
}

export default ListingDetailsMap;